import { render, staticRenderFns } from "./CampaignSelector.vue?vue&type=template&id=568cfffc&"
import script from "./CampaignSelector.vue?vue&type=script&lang=ts&"
export * from "./CampaignSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports